import {
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  VisitNoteSOAPSectionNames,
} from 'core/constants';
import {
  RTMSettingsDTO,
} from 'dtos';
import {
  getApiSettingsGetRTMSettings,
} from 'endpoints';
import {
  useGetSectionTemplateByName,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/hooks';

export const RTM_MONITORING_LABEL = 'Every two weeks · 52 weeks';

export const RTM_ATTESTATION_CRITERIA = [
  'RTM is not ordered for the convenience of the patient, provider, or caregiver.',
  'Patient is at risk of clinically significant changes warranting monitoring between visits.',
  'Scheduled visit frequency alone is insufficient to detect changes in time to intervene.',
  'Weekly monitoring is reasonably likely to prevent avoidable deterioration or adverse events.',
] as const;

export function useRTMSettings(enabled: boolean): UseQueryResult<RTMSettingsDTO, Error> {
  return useQuery<RTMSettingsDTO, Error>({
    queryKey: ['rtm-settings'],
    queryFn: getApiSettingsGetRTMSettings,
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

export function useRTMPlanTemplate(
  templateName: string,
  enabled: boolean,
): UseQueryResult<string, Error> {
  return useGetSectionTemplateByName(
    enabled ? templateName : '',
    VisitNoteSOAPSectionNames.PlanTemplate,
  );
}
